import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TriangleAlert } from 'lucide-react'
import storageService from '@/services/wallet/storage.service'
import Header from '@/components/Layout/Header/Header'

const ResetWallet = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [confirmed, setConfirmed] = useState(false)

  const handleReset = () => {
    storageService.clearWalletData(false)
    navigate('/', { replace: true })
  }

  return (
    <main className={`min-h-screen content-center p-8`}>
      <Header hideSidebar />
      <div className="flex flex-col w-full max-w-lg mx-auto gap-8">
        <div className="flex flex-col gap-4 p-6 rounded-2xl border border-red-500/30 bg-red-500/5">
          <div className="flex gap-3 items-start">
            <div className="w-10 h-10 rounded-full bg-red-500/10 flex items-center justify-center shrink-0">
              <TriangleAlert className="h-5 w-5 text-red-500" />
            </div>
            <div className="flex flex-col gap-3">
              <h1 className="text-xl font-bold text-text-main">
                {t('reset_wallet.title')}
              </h1>
              <p className="text-sm text-text-secondary leading-relaxed">
                {t('reset_wallet.desc')}
              </p>
              <p className="text-sm text-text-secondary leading-relaxed font-semibold">
                {t('reset_wallet.warning')}
              </p>
            </div>
          </div>
        </div>

        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
            className="w-5 h-5 accent-red-500"
          />
          <span className="text-sm text-text-main">
            {t('reset_wallet.confirm_checkbox')}
          </span>
        </label>

        <div className="flex flex-col gap-6">
          <button
            onClick={handleReset}
            disabled={!confirmed}
            className="w-full py-4 rounded-full bg-red-500 text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed transition-opacity"
          >
            {t('reset_wallet.confirm_button')}
          </button>
          <button
            onClick={() => navigate('/')}
            className="text-text-secondary text-sm font-medium self-center"
          >
            {t('dialogs.cancel')}
          </button>
        </div>
      </div>
    </main>
  )
}

export default ResetWallet
